import React from 'react';
import { UIWindowModal } from '../modals';
import { useLang } from '../../../_LangContext';
import Utils from '../../../_Utils';

const PopupConstruction = ({ isOpen, onClose }) =>
{
	const { getMessage } = useLang();
	const message = getMessage('under-construction');

	return (
		<UIWindowModal className="alert construction" isOpen={isOpen} onClose={onClose}>
			<div className="modal-container">
				<div className="modal-container-inner">
					<div className="alert-content">
						<div className="alert-icon">
							<p className="icon construction" />
						</div>
						<div className="message" dangerouslySetInnerHTML={{ __html: Utils.toBR(message) }} />
					</div>
				</div>
			</div>
		</UIWindowModal>
	);
};

export default PopupConstruction;

